import { create } from "zustand";
import axiosInstance from '../../api/axiosInstance';

interface Field {
  type: string;
  value: string;
  link?: string;
}

interface Section {
  id: number;
  section_name: string;
  payload: Record<string, Field>;
}

interface HomeState {
  sections: Record<string, Section>;
  faqs: [];
  fetchHelpContent: () => Promise<void>;
  fetchFAQ: () => void;
}

const useHelpStore = create<HomeState>((set) => ({
  sections: {},
  faqs: [],
  fetchHelpContent: async () => {
    try {
      const response = await axiosInstance.get("/cmsPages/help");
      const formattedSections = response.data.pages.rows.reduce(
        (acc: Record<string, Section>, section: any) => {
          try {
            // Try to parse the payload
            const parsedPayload = JSON.parse(section.payload);
            acc[section.section_name] = {
              id: section.id,
              section_name: section.section_name,
              payload: parsedPayload,
            };
          } catch (parseError) {
            console.log(section.payload);
            console.error("Error parsing payload for section:", section.section_name, parseError);
          }
          return acc;
        },
        {}
      );

      set({ sections: formattedSections });
    } catch (error) {
      console.error("Error fetching home content:", error);
    }
  },
  fetchFAQ: async () => {
    try {
        const response = await axiosInstance('active-faqs');
        set({ faqs: response.data });
      } catch (error) {
        console.error('Failed to fetch blogs:', error);
      }
  },
}));


export default useHelpStore;








